"use client"

import type React from "react"

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">Badkul Technology</h1>
          <span className="header-subtitle">QR Generator</span>
        </div>
      </div>
    </header>
  )
}

export default Header
